const filters = [
  {
    name: 'transmission',
    type: 'select',
    options: [
      {
        name: 'gearbox.Automatic',
        value: 'Automatic',
        translation: 'Automat',
      },
      {
        name: 'gearbox.Manual',
        value: 'Manual',
        translation: 'Manuell',
      },
    ],
  },
  {
    name: 'fuel',
    type: 'select',
    options: [
      {
        name: 'fuel.Electricity',
        value: 'Electricity',
        translation: 'Elektrisitet',
      },
      {
        name: 'fuel.GasolinAndElectricity',
        value: 'Gasolin & Electricity',
        translation: 'Elektrisitet+bensin',
      },
      {
        name: 'fuel.DieselAndElectricity',
        value: 'Diesel &  Electricity',
        translation: 'Elektrisitet+diesel',
      },
      {
        name: 'fuel.Gasolin',
        value: 'Gasolin',
        translation: 'Bensin',
      },
      {
        name: 'fuel.Diesel',
        value: 'Diesel',
        translation: 'Diesel',
      },
    ],
  },
  {
    name: 'driveWheel',
    type: 'select',
    options: [
      {
        name: 'drive.FrontWheelDrive',
        value: 'Front Wheel',
        translation: 'Forhjulsdrift',
      },
      {
        name: 'drive.RearWheelDrive',
        value: 'Rear Wheel',
        translation: 'Bakhjulsdrift',
      },
      {
        name: 'drive.FourWheelDrive',
        value: 'Four Wheel',
        translation: 'Firehjulsdrift',
      },
    ],
  },
  {
    name: 'location',
    type: 'select',
    options: [
      {
        name: 'location.haugesund',
        value: 'Haugesund',
        translation: 'Haugesund',
      },
      {
        name: 'location.odda',
        value: 'Odda',
        translation: 'Odda',
      },
    ],
  },
  {
    name: 'internalNumber',
    type: 'checkbox',
    options: [],
  },
  {
    name: 'internalNumber',
    type: 'checkbox',
    options: [],
  },
  {
    name: 'internalNumber',
    type: 'checkbox',
    options: [],
  },
  {
    name: 'price',
    type: 'range',
    symbol: 'NOK',
    options: [],
  },
  {
    name: 'mileage',
    type: 'range',
    symbol: 'km',
    options: [],
  },
];

export default filters;
